// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { navigationListStyles } from "@sc/Overrides/Widgets/Basic/NavigationList";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

navigationListStyles.link = {
    typographyProps: {
        size: 14,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 19px;
        `,
    },
};

navigationListStyles.splitter = {
    css: css`
        border-top: 1px solid ${color("common.border")};
        ${({ marginBottom }: any) => `margin-bottom: ${marginBottom}px`}
    `,
};
